import { apiGet, apiPost } from "./client";
import type {
  EngagementEvent,
  EngagementEventInput,
} from "@sales-ops-amplify/shared";

export async function listEngagements(params?: {
  opportunityId?: string;
  leadId?: string;
  limit?: number;
  q?: string;
}): Promise<EngagementEvent[]> {
  const res = await apiGet<{ engagements: EngagementEvent[] }>(
    "/api/engagements",
    params,
  );
  return res.engagements ?? [];
}

export async function createEngagement(
  input: EngagementEventInput,
): Promise<EngagementEvent> {
  const res = await apiPost<{ engagement: EngagementEvent }>(
    "/api/engagements",
    input,
  );
  return res.engagement;
}

export async function syncOpportunityEmail(
  opportunityId: string,
): Promise<{ created: number; scanned?: number; message?: string }> {
  return apiPost(
    `/api/engagements/sync-email?opportunityId=${encodeURIComponent(opportunityId)}`,
  );
}
